import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";
import JobsTableLayout from "@/pages/_layouts/jobs/JobsTableLayout";
import { useParams } from "react-router-dom";

export default function PersonJobPostings() {
  useRequireCapability({ domain: DOMAIN.JOBS, permission: PERMISSION.viewJobPosts });
  const { pgaId } = useParams();

  return (
    <JobsTableLayout
      firstUnderTabs="entity-detail"
      columnHeaders={{
        title: true,
        facility: true,
        serviceLevel: false,
        totalCompensation: false,
        employer: false,
        owner: false,
        postedOn: true,
        submissionDeadline: true,
        applicantCount: true,
        postingStage: true,
        jobStatus: true,
        section: true
      }}
      filters={{
        postingStage: true,
        jobStatus: true,
        serviceLevel: true,
        postedDateRange: true,
        section: false,
        owner: false
      }}
      defaultValues={{
        employerId: pgaId
      }}
      defaultSort={[{ id: "goLiveTime", desc: true }]}
    />
  );
}
